export const AMOUNT = {
    IN: 'amountIn',
    OUT: 'amountOut',
};

export const CURRENCY = {
    IN: 'currencyIn',
    OUT: 'currencyOut',
};

export const COUNTRY = {
    IN: 'countryIn',
    OUT: 'countryOut',
};

export class Calculator {
    constructor() {
        this.type = null;
        this.config  = null;
        this.product = null;
        this.directions = null;
        this.currencies = null;
        this.countryIn = null;
        this.countryOut = null;
        this.currencyIn = null;
        this.currencyOut = null;
        this.amountIn = null;
    }

    static create(data = { countryIn: 'gb', countryOut: 'pl', currencyIn: 'gbp', currencyOut: 'pln' }) {
        const {countryIn, currencyIn, countryOut, currencyOut} = data;
        return Object.assign(new Calculator(), data,
            {countryIn: countryIn && countryIn.toUpperCase()},
            {currencyIn: currencyIn && currencyIn.toUpperCase()},
            {countryOut: countryOut && countryOut.toUpperCase()},
            {currencyOut: currencyOut && currencyOut.toUpperCase()},
        );
    }
}